/**
 * when running in node.js without jsdom, this is true
 */
export const isSSR: boolean = !Boolean(
  typeof window !== 'undefined' && window.document?.createElement
)

export const isIE = Boolean(
  typeof window !== 'undefined' && window.document['documentMode']
)

export const isFirefox =
  typeof window !== 'undefined' &&
  navigator.userAgent.toLowerCase().indexOf('firefox') > -1
